import React, { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { supabase } from '../services/supabaseClient'
import { useAuth } from '../context/AuthContext'

export default function Login() {
  const { session } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  if (session) return <Navigate to="/" replace />

  const onSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password })
      if (error) throw error
    } catch (e) {
      setError(e.message || 'فشل تسجيل الدخول')
    } finally {
      setLoading(false)
    }
  }

  const signInWithGoogle = async () => {
    setError('')
    setLoading(true)
    try {
      const { error: oauthError } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: window.location.origin,
        },
      })
      if (oauthError) throw oauthError
    } catch (e) {
      setError(e.message || 'تعذر استخدام تسجيل الدخول عبر Google')
      setLoading(false)
    }
  }

  return (
    <div dir="rtl" style={{ maxWidth: 420, margin: '4rem auto', padding: 24, border: '1px solid #e5e7eb', borderRadius: 10, background: '#fff' }}>
      <h2 style={{ textAlign: 'center', marginBottom: 12 }}>Gate Attendance Scanner</h2>
      <div style={{ textAlign: 'center', marginBottom: 18, color: '#6b7280', fontSize: 13 }}>
        تسجيل الدخول لحساب بوابة المدرسة
      </div>

      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <input type="email" placeholder="البريد الإلكتروني" value={email} onChange={e => setEmail(e.target.value)} required />
        <input type="password" placeholder="كلمة المرور" value={password} onChange={e => setPassword(e.target.value)} required />
        {error && <div style={{ color: '#b91c1c', textAlign: 'right' }}>{error}</div>}
        <button type="submit" disabled={loading} style={{ padding: '10px 12px' }}>
          {loading ? 'جاري الدخول...' : 'دخول'}
        </button>
      </form>

      <div style={{ marginTop: 16, textAlign: 'center' }}>
        <span style={{ display: 'block', marginBottom: 8, color: '#6b7280', fontSize: 13 }}>أو</span>
        <button
          type="button"
          onClick={signInWithGoogle}
          disabled={loading}
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#f9fafb', width: '100%' }}
        >
          الدخول باستخدام Google
        </button>
      </div>
    </div>
  )
}
